module.exports = __webpack_public_path__ + "media/images/bsmartlabs-ee91f6983f1c04231b7d0f766986c10f.png";